import React from 'react';

export default ({ message, isSent }) => {
  const className = isSent
    ? 'form-text alert-success pl-5'
    : 'form-text alert-danger pl-5';
  return <small className={className}>{message}</small>;
};
